(function () {
  angular.module('MktzapApp.Factories')
    .factory('ChannelManager', ChannelManager);

  ChannelManager.$inject = ['$injector', '$rootScope'];

  function ChannelManager ($injector, $rootScope) {
    var supportedTypes = [ 'waent' ];
    return {
      isSupported: function (contact, key_name) { return supportedTypes.indexOf(this.getType(contact, key_name)) !== -1 },
      getIconClass: function (contact) {
        if (this.getType(contact) == 'waent') {
          return 'fa-whatsapp';
        }
      },
      getIconStyle: function (contact, icon_place) {
        // icon_place = chat_modal || chat_card
        if (this.getType(contact) == 'waent') {
          var padding_left = '12px';
          if (icon_place == 'chat_card') {
            padding_left = '7px';
          }
          return {
            'background-color': '#175f04',
            'padding-left': padding_left
          };
        }
        return {};
      },
      getProfileImg: function (contact) {
        return contact.profile_pic_public_path;
      },
      filterMetadata: function (contact, name_filter, vm_nameFilter) {
        if (this.getType(contact) == 'waent') {
          return name_filter || (contact.hasOwnProperty('data') && ((contact.data.hasOwnProperty('external_id') && contact.data.external_id.trim().toLowerCase().indexOf(vm_nameFilter.trim().toLowerCase()) != -1) || (contact.data.hasOwnProperty('contact_phone') && contact.data.contact_phone.trim().toLowerCase().indexOf(vm_nameFilter.trim().toLowerCase()) != -1)));
        }
        return false;
      },
      backToList: function ($state, company_id) {
        if ($state.params.type == 'waent') {
          $state.go('main.channels.waent', { id: company_id });
          return true;
        }
        return false;
      },
      getType: function (contact) {
        var key_name = 'id';

        if (
          !contact ||
                    !Object.keys(contact).length
        ) {
          return undefined;
        }

        if (contact['contact_id']) {
          key_name = 'contact_id';
        }

        if (!contact[key_name]) {
          return undefined;
        }

        var type = null;
        var parts = contact[key_name].split('_');
        if (parts.length > 0) {
          switch (parts[0]) {
            case 'em': type = 'email'; break;
            case 'wa':
            case 'waweb': type = 'whatsapp'; break;
            case 'web': type = 'web'; break;
            case 'sms': type = 'sms'; break;
            case 'fa': type = 'facebook'; break;
            case 'waent': type = 'waent'; break;
          }
        }

        return type;
      },
      getHistoryChannelTypes: function (contact) {
        return {
          Email: 'E-mail',
          Facebook: 'Facebook',
          WebChat: 'WebChat',
          Whatsapp: 'Whatsapp',
          SMS: 'SMS',
          Waent: 'Waent'
        };
      },
      getChannelName: function (contact) {
        switch (this.getType(contact)) {
          case 'waent': return 'Whatsapp Enterprise';
          default: return '';
        }
      },
      historyGetChannel: function (history) {
        switch (this.getType(history)) {
          case 'waent': return 'Whatsapp Enterprise';
          default: return '';
        }
      },
      isSizeLimited: function (contact) {
        switch (this.getType(contact)) {
          case 'waent': return true;
          default: return false;
        }
      },
      getLimitStringSize: function (contact) {
        switch (this.getType(contact)) {
          case 'waent': return 4096;
          default: return null;
        }
      },
      getHistoryContactData: function (history) {
        switch (this.getType(history)) {
          case 'waent': return [
            { name: $rootScope.labels.clientName, value: history.name },
            { name: $rootScope.labels.channel, value: 'Whatsapp Enterprise' }
          ];
          default: return [];
        }
      },
      getInstance: function (type) {
        switch (type) {
          // case "email": class_name = ""; break;
          // case "whatsapp": class_name = ""; break;
          // case "web": class_name = ""; break;
          // case "sms": class_name = ""; break;
          // case "facebook": class_name = ""; break;
          case 'waent': class_name = 'WaentChannel'; break;
        }

        return $injector.get(class_name);
      }
    };
  }
})();
